export class Currency {

    id: number|undefined;
    active:boolean;
    code: string;
    shortLabel:string;
    longLabel:string;
  
  }
  